import { useNavigate } from "react-router-dom";
import { CloseGreyIcon } from "../../assets/icons";

interface UnauthorizedUserModalProps {
    onClose: () => void;
}

const UnauthorizedUserModal: React.FC<UnauthorizedUserModalProps> = ({ onClose }) => {

    const navigate = useNavigate();

    return (
        <section className="modal-section need-to-login">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Potrebna je prijava</div>
                                <div className="description-text">Da biste nastavili, morate biti ulogovani. Prijavite se ili napravite nalog za par sekundi.</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-body-div">
                            <div className="div-block-62">
                                <div className="button-secondary" onClick={() => navigate("/register")}>
                                    <div>Registruj se</div>
                                </div>
                                <div className="button-primary go-to-login" onClick={() => navigate("/login")}>
                                    <div>Prijavi se</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default UnauthorizedUserModal;